import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { ReviewAnalysisState, ReviewAnalysisData } from '../../components/reviewAnalysis/types';

const initialState: ReviewAnalysisState = {
  data: null,
  loading: false,
  error: null,
};

const reviewAnalysisSlice = createSlice({
  name: 'reviewAnalysis',
  initialState,
  reducers: {
    fetchReviewAnalysisRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchReviewAnalysisSuccess: (state, action: PayloadAction<ReviewAnalysisData>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchReviewAnalysisFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchReviewAnalysisRequest,
  fetchReviewAnalysisSuccess,
  fetchReviewAnalysisFailure,
} = reviewAnalysisSlice.actions;

export default reviewAnalysisSlice.reducer;
